import { fetchAuditLogDiff, fetchDatabaseTablesAndColumns, fetchNthChanges } from '@/api/audit.api';
import type { GetNthChangesForTableQueryResponse } from '@condo/sdk/listing-persister';
import { useQuery } from '@tanstack/vue-query';
import { type MaybeRef, computed, unref } from 'vue';

export const useAuditDatabaseTablesAndColumns = (database: MaybeRef<string>) => {
    return useQuery({
        queryKey: computed(() => ['audit-database-tables-and-columns', unref(database)]),
        queryFn: async () =>
            fetchDatabaseTablesAndColumns({
                database: unref(database),
            }),
        initialData: () => ({}),
    });
};

export const useAuditLogDiff = (auditLogId: MaybeRef<string>) => {
    return useQuery({
        queryKey: computed(() => ['audit-log-diff', unref(auditLogId)]),
        queryFn: async () =>
            fetchAuditLogDiff({
                auditLogId: unref(auditLogId),
            }),
    });
};

export const useNthChanges = (nthChangesParams: MaybeRef<Parameters<typeof fetchNthChanges>[0]>, enabled?: MaybeRef<boolean>) => {
    return useQuery(
        computed(() => ['nth-changes', unref(nthChangesParams)]),
        async () => fetchNthChanges(unref(nthChangesParams)),
        {
            enabled,
            initialData: () => ({ auditLogs: [], total: 0 }) as GetNthChangesForTableQueryResponse,
        },
    );
};
